@import "~swiper/swiper.min.css";
@import "~swiper/modules/navigation/navigation.min.css";

:host {
  display: block;
}

.swiper-area {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.swiper-hero {
  font-family: var(--primary-font);
  position: relative;
  width: 100%;
  max-width: 1600px;
  height: auto;
  margin: 0 auto;
  overflow: hidden;

  .swiper-pagination-bullet {
    cursor: pointer;
  }

  .swiper-slide {
    background: var(--color-white);
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    height: auto;
    padding-left: 0px;
    padding-right: 0px;

    img {
      display: block;
    }
  }

  .swiper-navigation {
    :after {
      font-size: 32px;
      font-weight: var(--font-weight-bold);
      color: var(--color-white);
    }

    @include breakpointMax('md') {
      .swiper-button {
        &-next {
          top: unset;
          bottom: 70px;
          right: 15px;
        }
        &-prev {
          top: unset;
          bottom: 70px;
          left: 15px;
        }
      }
    }
  }

  .swiper-hero-pagination {
    position: absolute;
    text-align: center;
    @include layerIndex('fifth');
    bottom: 77px;
    left: 0;
    width: 100%;

    .swiper-pagination-bullet {
      display: inline-block;
      height: 15px;
      width: 15px;
      background-color: transparent;
      border: 1px solid var(--color-white);
      border-radius: 8px;
      margin: 3px;

      &-active {
        background-color: var(--color-white);
      }
    }
  }
}
